import styled from 'styled-components';
import { BaseButton } from '@stelecom/ui-react/components/buttons/baseButton';
import InputSimple, { phoneDecorator, nameDecorator, emailDecorator } from '@stelecom/ui-react/components/inputSimple';
import { COLORS, FONTS } from '@stelecom/ui-react/assets/js/constants';

const InputPhone = phoneDecorator(InputSimple);
const InputName = nameDecorator(InputSimple);
const EmailDecorator = emailDecorator(InputSimple);


export const Wrapper = styled.form`
    display: block;
    padding: 30px 40px 40px;
`;

export const Title = styled.h2`
    display: flex;
    font-weight: 800;
    font-size: 35px;
    line-height: 48px;
    color: ${COLORS.blueDark};
    margin-bottom: 33px;
    gap: 14px;

    & > img {
        width: 137.4px;
        height: 56px;
    }

    @media screen and (max-width: 859px) {
        flex-direction: column;
    }
`;

export const Inputs = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    width: 100%;
    gap: 14px;
    max-width: 420px;

    @media (max-width: 530px) {
        display: block;
    }
`;

export const Name = styled(InputName)`
    display: block;
    width: 100%;
    margin-bottom: 0;
    @media (max-width: 530px) {
        width: 100%;
        margin-bottom: 20px;
    }
`;

export const Phone = styled(InputPhone)`
    display: block;
    margin-bottom: 0;
`;

export const Email = styled(EmailDecorator)`
    display: block;
    margin-bottom: 0;
`;


export const ButtonBlock = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 16px;
    flex-wrap: nowrap;
    
    @media screen and (max-width: 530px) {
        display: block;
    }
`;

export const OrAuth = styled.div``;

export const Agree = styled.div`
    display: block;
    font-size: 12px;
    line-height: 17px;
    font-weight: 400;
    color: ${COLORS.darkGrey};
    a {    
        display: inline-block;
        border-bottom: 1px solid ${p => p.textColor ? p.textColor : COLORS.black};
        color: ${p => p.textColor ? p.textColor : COLORS.black};
    }
    @media (max-width: 1279px) {
        width: calc(100% - 254px);
    }
    @media screen and (max-width: 859px) {
        width: 100%;
        padding-left: 0;
    }
`;

export const Button = styled(BaseButton)`
    margin-right: 40px;

    @media screen and (max-width: 530px) {
        width: 100%;
        margin-bottom: 10px;
    }
`;

export const Message = styled.div`
    display: block;
    width: 100%;
    ${FONTS.XXL};
    p {
        margin: 15px 0;
    }
    a {
        ${FONTS.Medium};
        color: ${COLORS.lightBlue};
    }
`;
